import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import * as React from 'react';

import { AnalyticsStore, QueryRoute, RouteStore } from 'bernie-core';
import { ClickTracker } from 'bernie-analytics';
import { ErrorBoundary, Layer } from 'bernie-view';
import { LocalizedText } from 'bernie-l10n';

import { FeedbackModel } from 'models/common';

import { UitkSecondaryButton } from 'uitk-react-button';
import { UitkToast } from 'uitk-react-toast';

import { FeedbackDialog } from 'components/infosite/feedback/feedback-dialog';

const ButtonTracked = ClickTracker(UitkSecondaryButton);

export interface FeedbackButtonProps {
  routeStore?: RouteStore;
  analytics?: AnalyticsStore;
  model?: FeedbackModel;
}

export interface FeedbackButtonState {
  isShowMessaging: boolean;
}

@inject('routeStore', 'analytics')
@observer
export class FeedbackButton extends React.Component<FeedbackButtonProps, FeedbackButtonState> {
  private messagingTimeout = null;

  constructor(props) {
    super(props);
    this.state = {
      isShowMessaging: false
    };
    this.onFeedbackDismiss = this.onFeedbackDismiss.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  public componentWillUnmount() {
    clearTimeout(this.messagingTimeout);
  }

  private onFeedbackDismiss() {
    this.props.routeStore.goBack();
  }

  private onSubmit() {
    this.onFeedbackDismiss();
    this.setState({
      isShowMessaging: true
    });
    this.messagingTimeout = setTimeout(() => {
      this.setState({
        isShowMessaging: false
      });
    }, 2000);
  }

  public render() {
    const { analytics, routeStore, model } = this.props;
    if (!model || !model.feedbackText) {
      return null;
    }

    const feedbackOpenQuery = routeStore.mergeQueryString(routeStore.search, { pwaDialogNested: 'feedback' });

    return (
      <ErrorBoundary label="hotel.information.feedback">
        <>
          <div className="uitk-cell uitk-type-center all-y-padding-six">
            <h3 className="uitk-cell uitk-type-300 uitk-type-regular">
              <LocalizedText message="hotels.infosite.feedback.cta.title" />
            </h3>
            <div className="all-t-padding-two" data-stid="feedback-button">
              <ButtonTracked
                rfrr=":SendFeedback"
                linkName="SEND FEEDBACK"
                tag={Link}
                to={{ pathname: routeStore.pathname, search: feedbackOpenQuery }}
                text={model.feedbackText}
              />
            </div>
            <QueryRoute search={undefined} query={{ pwaDialogNested: 'feedback' }} match={false}>
              <Layer id="infosite-feedback" onDismiss={this.onFeedbackDismiss}>
                <FeedbackDialog onSubmit={this.onSubmit} analytics={analytics} onDismiss={this.onFeedbackDismiss} />
              </Layer>
            </QueryRoute>
          </div>

          {this.state.isShowMessaging && (
            <UitkToast show={this.state.isShowMessaging}>
              <LocalizedText message="hotels.infosite.feedback.messaging.text" />
            </UitkToast>
          )}
        </>
      </ErrorBoundary>
    );
  }
}
